import type { ThemeConfig } from "antd";
import { colors, radius, shadow, spacing, text, typography } from "./tokens";

/**
 * Ant Design theme built from the shared design tokens (`tokens.ts`).
 * This is the only place tokens are mapped onto AntD's `ThemeConfig`.
 */
export const antdTheme: ThemeConfig = {
	token: {
		colorPrimary: colors.primary.base,
		colorSuccess: colors.success.base,
		colorWarning: colors.warning.base,
		colorError: colors.error.base,
		colorInfo: colors.info.base,
		colorLink: colors.info.base,
		colorLinkHover: colors.primary.hover,
		colorTextBase: text.primary,
		colorBgLayout: colors.neutral[50],
		colorBorder: colors.neutral[300],
		borderRadius: radius.base,
		fontFamily: typography.fontFamily,
		fontSize: typography.fontSizeBase,
		controlHeight: 36,
		boxShadow: shadow.base,
	},
	components: {
		Layout: {
			siderBg: colors.sider.bg,
			headerBg: colors.neutral[0],
			headerHeight: 64,
			bodyBg: colors.neutral[100],
		},
		Menu: {
			darkItemBg: colors.sider.bg,
			darkItemSelectedBg: colors.sider.itemSelectedBg,
			darkItemHoverBg: colors.sider.itemHoverBg,
		},
		Table: {
			headerBg: colors.neutral[50],
			headerColor: text.secondary,
			rowHoverBg: colors.primary.light,
			cellPaddingBlock: spacing.sm + 4,
		},
		Card: {
			borderRadiusLG: radius.lg,
			boxShadowTertiary: shadow.sm,
		},
		Button: {
			borderRadius: radius.base,
			controlHeight: 36,
			fontWeight: 500,
		},
	},
};
